/**
 * 挑战列表页 /challenges 内存缓存（SPA 内有效）。
 * 按分页+筛选缓存列表，单独缓存「进行中」数据；再次进入先展示缓存，后台再拉最新。
 */

const LIST_MAX = 32
const listCache = new Map()

function listKey(current, size, level, category) {
  return `${current}|${size}|${level ?? ''}|${category ?? ''}`
}

export function getChallengesListCache(current, size, level, category) {
  const v = listCache.get(listKey(current, size, level, category))
  if (!v) return null
  return {
    records: (v.records || []).map((r) => ({ ...r })),
    total: v.total ?? 0
  }
}

export function setChallengesListCache(current, size, level, category, records, total) {
  const k = listKey(current, size, level, category)
  if (listCache.size >= LIST_MAX) {
    listCache.delete(listCache.keys().next().value)
  }
  listCache.set(k, {
    records: (records || []).map((r) => ({ ...r })),
    total: total ?? 0
  })
}

let ongoingCache = null

export function getOngoingCache() {
  if (!ongoingCache) return null
  return {
    ongoingAttempts: (ongoingCache.ongoingAttempts || []).map((a) => ({ ...a })),
    challengeTitles: ongoingCache.challengeTitles ? { ...ongoingCache.challengeTitles } : {}
  }
}

export function setOngoingCache(ongoingAttempts, challengeTitles) {
  ongoingCache = {
    ongoingAttempts: (ongoingAttempts || []).map((a) => ({ ...a })),
    challengeTitles: challengeTitles ? { ...challengeTitles } : {}
  }
}
